import React from "react";
import { nanoid } from "nanoid";
import { addCurrencyWord } from "../../../../utils";
import { IProduct } from "../../types";
import styles from "./ProductItem.module.scss";

export interface ProductItemProps {
  product: IProduct;
  onDelete: (productId: number) => void;
  onIncrease: (productId: number) => void;
  onDecrease: (productId: number) => void;
}

export const ProductItem: React.FC<ProductItemProps> = ({
  product,
  onDelete,
  onIncrease,
  onDecrease,
}) => {
  const currentPrice = (product.price || 0) * (product.count || 1);
  const productCount = product.count || 1;

  console.log(product);
  

  return (
    <div key={nanoid()} className={styles.productItem}>
      <div className={styles.productItemContainer}>
        <div className={styles.productInfoContainer}>
          <p className={styles.productName}>
            {product.productName}
          </p>
          <div>
            <p className={styles.date}>
              {product.price} руб. за штуку
            </p>
          </div>
        </div>
        <div className={styles.productPriceContainer}>
          <button
            className={styles.productDeleteButton}
            onClick={() => onDelete(product.productId)}
            aria-label="Удалить"
          />
          <p className={styles.productPrice}>{addCurrencyWord(currentPrice)}</p>
          <div className={styles.productCountControls}>
            <button
              className={`${styles.productCountButton} ${styles.productBorderWidth}`}
              onClick={() => onDecrease(product.productId)}
              disabled={productCount <= 1}
            >
              <span className={styles.countButtonIcon}>-</span>
            </button>
            <div className={styles.productCountText}>{productCount}</div>
            <button
              className={`${styles.productCountButton} ${styles.productBorderWidth}`}
              onClick={() => onIncrease(product.productId)}
            >
              <span className={styles.countButtonIcon}>+</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
